import { Modal, Input } from "antd";
import React from "react";

const { TextArea } = Input;

const ReasonModal = (props: any) => {
  return (
    <Modal
      open={props.showModal}
      onCancel={props.onCancel}
      afterClose={props.afterClose}
      okText="Yes"
      cancelText="Cancel"
      footer={props.footer}
      maskClosable={false}
    >
      <div className="flex flex-col gap-2 items-center">
        {props.icon}
        <span className="text-center">{props.title}</span>
        <TextArea
          rows={4}
          placeholder="Enter reason..."
          value={props.reasonValue}
          onChange={props.onReasonChange}
          className="w-full mt-3"
        />
        <span className="text-[13px] text-gray-600 text-center">
          {props.body}
        </span>
      </div>
      {props.children}
    </Modal>
  );
};

export default ReasonModal;
